import { createSelector } from '@reduxjs/toolkit';

import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const bannersSelector = rootStateBranchSelector('banners');

export const bannersHashSelector = createSelector(bannersSelector, state => state.hash);
